__turbopack_context__.v({
  "exitSurveyIcon": "ExitSurveyModal-module___nOCiG__exitSurveyIcon",
  "exitSurveyModalWrapper": "ExitSurveyModal-module___nOCiG__exitSurveyModalWrapper",
  "exitSurveyMsgContent": "ExitSurveyModal-module___nOCiG__exitSurveyMsgContent",
  "exitSurveyMsgWrapper": "ExitSurveyModal-module___nOCiG__exitSurveyMsgWrapper",
});
